export class AppConfigModel {
  public issuer: string = '';
  public clientId: string = '';
  public responseType: string = '';
  public scope: string = '';
  public clientSecret: string = '';
  public redirectUri: string = '';
  public logoutUrl: string = '';
}
